// extracted by mini-css-extract-plugin
export var dataCell = "_ob-2";
export var dataRow = "_ob-0";
export var headerRow = "_ob-1";